import React from 'react';
//import { Button } from 'reactstrap';
import { connect } from 'react-redux';
//import { Link } from 'react-router-dom';

function Plan() {
    return (
        <div className="account-card">
            <div className="mt-3 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center justify-content-between">
                    <div><h4>Your plan:&nbsp;Free trial</h4></div>
                </div>
                {/*<Link to="/pricing">
                    <Button
                        style={{ width: '100px', color: 'white' }}
                        className="px-4"
                        color="info"
                    >
                        Update
                    </Button>
                </Link>*/}
            </div>
            {/*
                <div
                    style={{ paddingLeft: '20%' }}
                    className="mb-3 mt-2 d-flex align-items-center"
                >
                    <ul style={{ listStyle: 'none' }}>
                        <li>
                            <i
                                style={{ color: '#888888' }}
                                className="fa fa-check mr-2"
                            />
                            Benefit 1
                        </li>
                        <li>
                            <i
                                style={{ color: '#888888' }}
                                className="fa fa-check mr-2"
                            />
                            Benefit 2
                        </li>
                        <li>
                            <i
                                style={{ color: '#888888' }}
                                className="fa fa-check mr-2"
                            />
                            Benefit 3
                        </li>
                    </ul>
                </div>
            */}
        </div>
    );
}

const mapStateFromProps = ({ auth }) => ({
    auth
});

export default connect(mapStateFromProps)(Plan);
